import richTextFragment from '@components/renderers/rich-text.fragment'
import { testimonialV2Fragment } from '@components/testimonialv2/testimonialv2.fragment'
import richTextFragmentCut from '@components/renderers/rich-text.fragment-cut'

const weLoveThisGameFragment = `
  metaDataField
  metaDescription
  metaImage {
    url
    description
  }
  hero {
    url
    description
  }
  heroMobile {
    url
    description
  }
  logo {
    url
    description
  }
  whoWeAreSection {
    heading
    cardHeading
    longSupportiveCopy
    cardSupportiveCopy
    cardImage {
      url
      description
    }
    backgroundImage {
      url
      description
    }
    cardVideo {
      url
      description
    }
    cardVideoAssociatedImage {
      url
      description
    }
  }
  heroText
  videoSpotlight {
    headline
    overlineText
    description {
      ${richTextFragment}
    }
    ctaText
    link
    videoImage {
      url
      description
    }
    video {
      url
      description
    }
    videoEmbedId
  }
  testimonialsSection {
    ${testimonialV2Fragment}
  }
  eventsCollection(limit: 6) {
    items {
      title
      eventYear
      logo {
        url
        description
      }
      eventHeadline
      relevantStoriesCtaText
      relevantStoriesCtaLink
    }
  }
  timelineStyle
  ourHistoryHeader
  ourHistorySupportText
  ourHistorySupportRichText {
    ${richTextFragment}
  }
  ourHistoryBackgroundImage {
    url
    description
  }
  categorySectionOvertext
  categorySectionHeadline
  categorySectionSubtitle
  categories
  ctaCardCollectionCollection {
    items {
      title
      series
      summaryLong
      ctaText
      externalLink
      image {
        url
        description
      }
    }
  }
  governingBodiesPdf {
    url
  }
  govBodiesCta {
    heading
    supportiveCopyRich {
      ${richTextFragmentCut}
    }
    buttonLabel
  }
  govBodiesImage {
    url
    description
  }
`

export default weLoveThisGameFragment
